export default {
  requests(state) {
    return state.requestsData
  },

}